'use client'

import { Button } from '@/components/ui/button'
import { ImageHelper } from '@/lib/helpers/image.helper'
import { ArrowRight } from 'lucide-react'
import Image from 'next/image'
import { FC } from 'react'
import { useTranslations } from 'next-intl'

export const ProudlyMadeInSection: FC = () => {
  const t = useTranslations('ldp_amazon_hardcode.proudly_made_in')

  return (
    <div className='relative'>
      <picture>
        <source
          media='(max-width: 768px)'
          srcSet={ImageHelper.getImageUrl('/image/October2025/mceclip14.jpg')}
        />
        <Image
          src={ImageHelper.getImageUrl('/image/October2025/mceclip9.jpg')}
          alt='Proudly Made In Vietnam Background'
          width={100}
          height={100}
          className='h-auto w-full object-contain'
        />
      </picture>
      <div className='absolute left-6 top-[32%] -translate-y-1/2 md:left-12 md:top-1/2 2xl:left-32'>
        <div className='font-criteria text-base font-semibold text-white md:text-4xl'>
          {t.rich('title', {
            newline: () => <br />,
          })}
        </div>
        <Button
          size='small'
          className='mt-2 flex items-center gap-1 max-md:text-xs md:mt-9 md:gap-2'
          variant='white'
          onClick={() => {
            window.open(
              'https://www.amazon.com/stores/page/3ED8D0AD-F012-4D73-8F59-ED8C29011D0E?ingress=2&lp_context_asin=B0DZ6V3LYW&visitId=d8f44573-97dc-4236-bd6e-8c7d9109c04d&store_ref=bl_ast_dp_brandLogo_sto&ref_=ast_bln',
              '_blank'
            )
          }}
        >
          {t('button_text')}
          <ArrowRight />
        </Button>
      </div>
    </div>
  )
}
